import React from 'react'
import styles from'./mobileTabsComponent.module.css';
import { mobileTabs } from "./livechat.data";

const MobileTabsComponent = ({ tabValue, handleTabChange }) => {
    return (
        <div className={styles.tabContainer}>
          {/* Map through the tabs array */}
          {mobileTabs.map((tab, index) => (
            <button
                key={index}
                className={`${styles.tab} ${tabValue=== index ? styles.activeTab: ''}`}
                onClick={() => handleTabChange(null,index)}
            >
              <img src={tab?.tabIcon} alt={tab?.tabName} className={styles.tabIcon} />
            </button>
          ))}
        </div>
      );
}

export default MobileTabsComponent